import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import useBreakpoint from "../hooks/useBreakpoint"

export const FeaturedVideo = ({ videoUrl }, { videoUrl: string }) => {
  return (
    <div className="featured-video">
      <iframe
        src={videoUrl}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  )
}

interface MediaWall {
  sanityLiveMediaWall: {
    wallUrl: string
  }
}

const LiveWall = () => {
  const { sanityLiveMediaWall }: MediaWall = useStaticQuery(graphql`
    query {
      sanityLiveMediaWall {
        wallUrl
      }
    }
  `)

  const { wallUrl } = sanityLiveMediaWall
  if (!wallUrl) return null

  return (
    <iframe
      className="live-wall"
      allowFullScreen
      frameBorder="0"
      id="wallsio-iframe-top"
      src={`${wallUrl}?nobackground=1&amp;show_header=0`}
      loading="lazy"
      title="Right Livelihood Social Wall"
    ></iframe>
  )
}

export const LiveVideo = ({ videoUrl }, { videoUrl: string }) => {
  const { isMobile } = useBreakpoint()

  return (
    <>
      <div className="featured-video featured-video--live">
        <iframe
          src={videoUrl}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
        {!isMobile && (
          <div className="featured-video__media-wall">
            <LiveWall />
          </div>
        )}
      </div>
      {isMobile && <LiveWall />}
    </>
  )
}
